import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {OrbitProject} from '@/model/resource/OrbitProject'

@HttpExclude()
export class OrbitProjectCollection extends ExpansibleCollection<OrbitProject> {
  resource?: IOrbitProjectCollectionResourcesHolder

  @RequestExpose() active: boolean | null = null
  @RequestExpose() limit: number | null = null
  @RequestExpose() round: number[] | null = null
  @RequestExpose() hashes: string[] | null = null
  @RequestExpose() idDappFk: number[] | null = null
  @RequestExpose() onlyRunningOrNullRound: boolean | null = null
  /** blockchain_version.networkIdentifier: 'neo3/mainnet' | 'neo3/testnet' */
  @RequestExpose() networkIdentifier: string | null = null

  constructor() {
    super(OrbitProject)
  }

  queryAsPage() {
    return this.listOrbitProject()
  }

  async listOrbitProject() {
    return await Request.get(`/client/orbit-project`, {params: this.params})
      .name('listOrbitProject')
      .as(this)
      .getResponse()
  }

  showOnlyRunningOrNullRound(active: boolean) {
    this.onlyRunningOrNullRound = active ? true : null
  }

  async countUserRoundParticipations(address: string): Promise<number> {
    const params: Record<string, string> = {address}
    return await Request.get(
      `/client/orbit-project/count-round-participations`,
      {
        params,
      }
    )
      .name('countUserRoundParticipations')
      .asNumber()
      .getData()
  }
}

export interface IOrbitProjectCollectionResourcesHolder {}
